"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ToggleButton_meta_1 = require("../ToggleButton.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('section', ToggleButton_meta_1.TOGGLE_BUTTON_CATEGORY_KEY, ToggleButton_meta_1.TOGGLE_BUTTON_COMPONENT_KEY, ['wrapper']);